import { useState } from 'react';

import cx from '../../../../utils/cx';

import RadioButton from '../../shared/RadioButton/RadioButton';
import Typography, { FONT_TYPES } from '../../shared/Typography/Typography';

import styles from './ShortChoice.module.scss';

const ShortChoice = ({ stepName, texts, isRow, initialChecked = -1, onNext }) => {
  const [checkedIndex, setCheckedIndex] = useState(initialChecked);
  const { title, subtitle, answers } = texts[stepName];

  const handleClick = (index) => () => {
    if (checkedIndex !== -1) return;

    setCheckedIndex(index);
    onNext(index);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.card}>
          <div className={styles.texts}>
            <Typography type={FONT_TYPES.h2} className={styles.title} isCenter>
              {title}
            </Typography>
            {subtitle && (
              <Typography type={FONT_TYPES.small_regular} className={styles.subtitle} isCenter>
                {subtitle}
              </Typography>
            )}
          </div>
          <div className={cx(styles.answers, { [styles.answersRow]: isRow })}>
            {answers.map((text, index) => (
              <RadioButton
                key={`${stepName}_${index}`}
                id={`${stepName}_${index}`}
                name={stepName}
                className={cx({ [styles.answerRow]: isRow })}
                checked={checkedIndex === index}
                onChange={handleClick(index)}
              >
                {text}
              </RadioButton>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShortChoice;
